var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datatable',{ref:"dtComponent",attrs:{"modelData":_vm.dtData,"activeFieldName":"active"},on:{"deleteItem":_vm.deleteIncentiveItem,"activeHandled":_vm.incentiveActiveUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }